<template>
    <div>
        <div
            v-cloak
            class="row"
        >
            <div class="col-xs-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Info</h3>
                        <div class="box-tools pull-right">
                            <button
                                class="btn btn-box-tool"
                                title="Collapse"
                                type="button"
                                @click="toggleCollapse"
                            >
                                <i
                                    :class="changeIcon(collapse)"
                                    class="fa"
                                ></i>
                            </button>
                        </div>
                    </div>
                    <!-- /.box-header -->
                    <vue-slide-up-down
                        :active="collapse"
                        :duration="durationCollapse"
                    >
                        <div>
                            <div
                                v-if="tag.id"
                                class="box-body"
                            >
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Name:</strong>
                                        <p>{{ tag.name }}</p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Active:</strong>
                                        <p>
                                            <value-yes-no :value="tag.active" />
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Created At:</strong>
                                        <p>{{ tag.created_at }}</p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Updated At:</strong>
                                        <p>{{ tag.updated_at }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-6">
                                        <strong>Description:</strong>
                                        <p>
                                            {{ tag.description }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-slide-up-down>
                </div>
            </div>
        </div>
        <FilterDataSelector :enable-filter="isDisabledFilter()" />
        <TemplateComponent
            :entity-id="tagId"
            :entity-name="'tags'"
            :query-filter="filter"
        />
    </div>
</template>

<script>
import ValueYesNo from '../../subcomponents/ValueYesNo';
import FilterDataSelector from '../../subcomponents/FilterDataSelector';
import TemplateComponent from '../templates/TemplateComponent';
import EventBus from '../../../event-bus';

export default {
    components: {
        ValueYesNo,
        FilterDataSelector,
        TemplateComponent,
    },
    props: {
        tagId: {
            type: Number,
            default: null,
        },
    },

    data: function () {
        return {
            tag: {},
            lists: {},
            disableProps: {
                disableBtn: 'disable-btn',
                disableWrapper: 'disable-wrapper',
                preventEnterFilter: true,
            },
            isLoaded: false,
            pageNumber: this.$route.query.page,
            pageID: this.$route.params.id,
            disableFilterLists: false,
            collapse: true,
            durationCollapse: 700,
        };
    },
    computed: {
        filter: function () {
            return this.$route.query['filter[dates]'] ? '?' + encodeURI('filter[dates]=' + this.$route.query['filter[dates]']) : '';
        },
    },
    created() {
        EventBus.$on('disableFilterList', (data) => {
            this.disableFilterLists = data.disableFilter;
        });
    },
    mounted() {
        this.getData(this.tagId);
    },
    methods: {
        isDisabledFilter: function () {
            return this.disableFilterCarriers || this.disableFilterOffers || this.disableFilterLists ? this.disableProps : {};
        },
        getData(id) {
            this.isLoaded = false;
            axios
                .get('/lists/tags/' + id + '/data')
                .then((response) => {
                    this.tag = response.data.tag;
                })
                .catch(() => {});
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
